export const updateDomain = domain => ({ type: "UPDATE_DOMAIN_SEKOLAH", domain });


// WEBPACK FOOTER //
// ./src/actions/domainAction.js